<template>
  <div class="fullscreen-container">
    <div class="thanks-card">
      <div class="blob blob-1"></div>
      <div class="blob blob-2"></div>

      <div class="card-content">
        <div class="confetti-emoji">🎉</div>

        <h2 class="thanks-title">
          <span v-if="nickname">Terima kasih, <span class="nickname-thanks">{{ nickname }}</span>!<br/>Terima Kasih Telah</span>
          <span v-else>Terima Kasih<br/>Telah</span>
          berpartisipasi!
        </h2>
        <p class="subtitle">
          See you on <br>
          Petra Parade 2026!
        </p>
        <!-- <button @click="$emit('retake')" class="retake-button">Ulangi Test</button> -->
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  nickname: {
    type: String,
    default: ''
  }
});
defineEmits(['retake']);
</script>

<style scoped>
/* Container utama yang memenuhi layar */
.fullscreen-container {
  height: 100%;
  border-radius: 20px;
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #6DD5FA, #2980B9);
  background-image: url('~@/assets/pcu/asset-PP-07-cropped.png');
  background-size: cover;           /* atau: contain */
  background-repeat: no-repeat;
  background-position: center;
}

/* Kartu putih di tengah */
.thanks-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 2.5rem;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
  position: relative;
  overflow: hidden;
  animation: card-appear 0.6s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
}

@keyframes card-appear {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Dekorasi blob di belakang konten */
.blob {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  filter: blur(20px);
  z-index: 0;
}
.blob-1 {
  width: 200px;
  height: 200px;
  background-color: #FF6B6B; /* Merah */
  top: -50px;
  left: -50px;
}
.blob-2 {
  width: 150px;
  height: 150px;
  background-color: #feca57; /* Kuning */
  bottom: -50px;
  right: -50px;
}

/* Konten di atas dekorasi */
.card-content {
  position: relative;
  z-index: 1;
}

.confetti-emoji {
  font-size: 5rem; /* Ukuran emoji diperbesar */
  line-height: 1;
  margin-bottom: 1.5rem;
  animation: float-confetti 2s ease-in-out infinite;
}

h2 {
  color: #2c3e50;
  font-size: 2rem;
  font-weight: 800;
  line-height: 1.3;
  margin-bottom: 0.75rem;
}

.nickname-thanks {
  color: #2980B9;
}

.subtitle {
  color: #555;
  font-size: 1.1rem;
  margin: 0 auto 2.5rem auto;
}

.retake-button {
  background-color: transparent;
  color: #2980B9;
  border: 2px solid #2980B9;
  padding: 12px 28px;
  font-family: 'Epilogue', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.retake-button:hover {
  background-color: #2980B9;
  color: #fff;
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(41, 128, 185, 0.3);
}
@media (max-width: 768px) {
  .thanks-title {
    font-size: 1.2rem;
  }
}
</style>